import React from "react";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import { Box, Typography } from "@mui/material";

const NotFound = ({ version }) => {
  return (
    <Box component="main" sx={{ display: "flex" }}>
      <Typography>Don't be hasty! GBS {version} continues...</Typography>
      <SentimentSatisfiedAltIcon color="primary" sx={{ pl: 1 }} />
    </Box>
  );
};

export default NotFound;
